import { Layout } from 'antd';
import styled from 'styled-components';

const { Content } = Layout;

export const StyledContent = styled(Content)`
  margin-top: 86px;
`;

export const SubHeader = styled.div`
  margin-bottom: 20px;
`;
